import React from 'react';

import {type WBTableColumn} from './types';
import {
  WBTableCellColumnHeader,
  type WBTableCellColumnHeaderProps,
} from './WBTableCellColumnHeader';

export type ChildPropsFn = (
  column: WBTableColumn,
  columnIndex: number
) => WBTableCellColumnHeaderProps;

interface WBTableColumnHeaderProps {
  childProps: ChildPropsFn;
  columns: WBTableColumn[];
  displayedRows: any[]; // table rows that are displayed in the current page
}

export function WBTableColumnHeaders({
  columns,
  childProps,
  displayedRows,
}: WBTableColumnHeaderProps) {
  return (
    <>
      <div className="wb-tree-padding" />
      {columns.map((column, columnIndex) => {
        const props = childProps(column, columnIndex);
        return (
          <WBTableCellColumnHeader
            {...props}
            displayedRows={displayedRows}
            // oxlint-disable-next-line react/no-array-index-key -- https://oxc.rs/docs/guide/usage/linter/rules/react/no-array-index-key.html
            key={columnIndex}
          />
        );
      })}
      <div className="wb-tree-padding" />
      <div className="wb-tree-padding" />
    </>
  );
}
